import type { DietaryRequirement } from './types'

/** Labels for the requirements a guest can declare. */
export const DIETARY_LABEL: Record<DietaryRequirement, string> = {
  vegetarian: 'Vegetarian',
  vegan: 'Vegan',
  gluten_free: 'Gluten free',
}

/** The order they are offered in, narrowest last. */
export const DIETARY_OPTIONS: readonly DietaryRequirement[] = [
  'vegetarian',
  'vegan',
  'gluten_free',
]
